import React, { Component } from 'react'
import { Row, Col, Modal, Form, Button } from 'react-bootstrap';
import { components } from 'react-select'
import DateTime from 'react-datetime'

import { Scrollbars } from 'react-custom-scrollbars'
import SelectDropDown from '../selectdropdown/SelectDropDown';
import './_quiz.scss';
import MultiSelect from "react-multi-select-component";
import * as Cookies from "es-cookie";
import moment from 'moment'

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class QuizModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    errorMessage() {
        if (this.props.stateData.currentStep == 5) {
            return (
                <div>
                    <h5 className="text-uppercase">Quiz paper <br />Generated successfully</h5>
                    <div className="icon my-4">
                        <svg role="img" viewBox="0 0 512 512" width="50" height="50" xmlns="http://www.w3.org/2000/svg">
                            <path fill="green" d="M345.34 182.46a7.98 7.98 0 0 0-5.66-2.34c-2.05 0-4.1.78-5.66 2.34L226.54 289.94l-48.57-48.57a7.98 7.98 0 0 0-5.66-2.34c-2.05 0-4.1.78-5.66 2.34l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l65.54 65.54c1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.65-2.34l124.45-124.45c3.12-3.12 3.12-8.19 0-11.31l-11.3-11.31zM512 256c0-35.5-19.4-68.2-49.6-85.5 9.1-33.6-.3-70.4-25.4-95.5s-61.9-34.5-95.5-25.4C324.2 19.4 291.5 0 256 0s-68.2 19.4-85.5 49.6c-33.6-9.1-70.4.3-95.5 25.4s-34.5 61.9-25.4 95.5C19.4 187.8 0 220.5 0 256s19.4 68.2 49.6 85.5c-9.1 33.6.3 70.4 25.4 95.5 26.5 26.5 63.4 34.1 95.5 25.4 17.4 30.2 50 49.6 85.5 49.6s68.1-19.4 85.5-49.6c32.7 8.9 69.4.7 95.5-25.4 25.1-25.1 34.5-61.9 25.4-95.5 30.2-17.3 49.6-50 49.6-85.5zm-91.1 68.3c5.3 11.8 29.5 54.1-6.5 90.1-28.9 28.9-57.5 21.3-90.1 6.5C319.7 433 307 480 256 480c-52.1 0-64.7-49.5-68.3-59.1-32.6 14.8-61.3 22.2-90.1-6.5-36.8-36.7-10.9-80.5-6.5-90.1C79 319.7 32 307 32 256c0-52.1 49.5-64.7 59.1-68.3-5.3-11.8-29.5-54.1 6.5-90.1 36.8-36.9 80.8-10.7 90.1-6.5C192.3 79 205 32 256 32c52.1 0 64.7 49.5 68.3 59.1 11.8-5.3 54.1-29.5 90.1 6.5 36.8 36.7 10.9 80.5 6.5 90.1C433 192.3 480 205 480 256c0 52.1-49.5 64.7-59.1 68.3z"></path>
                        </svg>
                    </div>

                </div>



            );

        }
        else {
            return (<Form.Text className="form-text text-danger">
                {this.props.stateData.submitError1}
            </Form.Text>);

        }


    }
    getClassData() {
        console.log("sdddd", this.props)
        let getArray = [];
        // let newDefault = {
        //     value: 0,
        //     label: "ALL"
        // }
        // getArray.push(newDefault);
        for (let i = 0; i <= this.props.globals.classes.length; i++) {
            let idata = this.props.globals.classes[i];
            if (idata != undefined) {
                const newObj = {
                    value: idata.id,
                    label: idata.class
                }
                getArray.push(newObj);

            }
        }
        return getArray;
    }



    render() {
        const modelStep = this.props
        console.log("modelStep", modelStep);
        var yesterday = DateTime.moment().subtract(1, 'day');

        var valid = function (current) {
            return current.isAfter(yesterday);
        };

        console.log("aravindww", this.props.stateData.startdate)

        let qtypeselectall = true;
        let qtypelabelledBy = "Select";
        let qtypedisableSearch = false;
        if (this.props.getSections.length > 0) {
            qtypeselectall = true;
            qtypedisableSearch = false;
        }
        else {
            qtypedisableSearch = true;
            qtypeselectall = false;
            qtypelabelledBy = "No Options"
        }

        return (
            <Modal {...this.props} className='quiz_modal'
                size="md" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton className='p-2'>
                    <Modal.Title><h5 className='modal_title_color text-white'>Assign & Schedule Quiz</h5></Modal.Title>
                </Modal.Header>
                {/*<Button variant="link" className='closebtn' onClick={() => { this.props.onHide() }}> <i className="fas fa-times" /> </Button>*/}
                <Modal.Body className="p-4" style={{
                    width: '100%',
                    height: '450px',
                    overflow: 'auto',
                }}>

                    {
                        this.props.stateData.currentStep != 5 ?
                            (
                                <>
                                    <Row>
                                        <Col sm={12}>
                                            <Form.Group controlId="formCategory">
                                                {/*<Form.Label className="f-14">Name of the Quiz</Form.Label>*/}
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Name of the Quiz"
                                                    name="exam_name"
                                                    onChange={this.props.phandleInputChange}
                                                    autoComplete="off"
                                                    value={this.props.stateData.exam_name}
                                                />

                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>
                            )
                            :
                            ("")
                    }



                    <Row>
                        <Col sm={12} className="text-center">
                            {this.errorMessage()}
                        </Col>
                        {
                            this.props.stateData.currentStep != 5 ?
                                (
                                    <>

                                        <Col sm={12}>
                                            <Form className="">
                                                <Form.Row>
                                                    <Form.Group as={Col} lg={12} md={12} sm={12} controlId="StartDate" className="mbottom_5">
                                                        <Form.Label className="text-uppercase">Start Date & Time</Form.Label>
                                                        <DateTime
                                                            // dateFormat="DD-MM-YYYY" 
                                                            // inputProps={{ placeholder: 'Start Date' }} 
                                                            name="startdate"
                                                            dateFormat="DD-MM-YYYY"
                                                            inputProps={{ placeholder: 'Ex: 02-04-1995' }}
                                                            onChange={this.props.parentpdatefunction}
                                                            isValidDate={valid}
                                                            defaultValue={this.props.stateData.startdate == "" ? "" : moment.unix(this.props.stateData.startdate).format("DD-MM-YYYY LT")}
                                                        />
                                                    </Form.Group>
                                                    {
                                                        Cookies.get("institutionid") == 19 ?
                                                            (
                                                                <Form.Group as={Col} lg={12} md={12} sm={12} controlId="endDate" className="mbottom_5 mt-5">
                                                                    <Form.Label className="text-uppercase">End Date & Time</Form.Label>
                                                                    <DateTime
                                                                        // dateFormat="DD-MM-YYYY" 
                                                                        // inputProps={{ placeholder: 'Start Date' }} 
                                                                        name="enddate"
                                                                        dateFormat="DD-MM-YYYY"
                                                                        inputProps={{ placeholder: 'Ex: 02-04-1995' }}
                                                                        onChange={this.props.parentpdatefunctionend}
                                                                        isValidDate={valid}
                                                                        defaultValue={this.props.stateData.enddate == "" ? "" : moment.unix(this.props.stateData.enddate).format("DD-MM-YYYY LT")}
                                                                    />
                                                                </Form.Group>
                                                            )
                                                            :
                                                            ("")
                                                    }

                                                </Form.Row>
                                            </Form>
                                        </Col>



                                    </>
                                )
                                :
                                ("")
                        }
                    </Row>



                    <Row className='mt-3'>
                        <Col sm={6}>
                            <Form.Group controlId="SelectClass">
                                {/*<Form.Label className="f-14">Class </Form.Label>*/}
                                <SelectDropDown
                                    stateData={this.props.stateData.classvalue}
                                    handleChange={this.props.pselecthandleInputChange}
                                    name="class"
                                    options={this.getClassData()}
                                    placeholderName={'Class'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="Selectsections">
                                {/*<Form.Label className="f-14">Section </Form.Label>*/}
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All Sections are selected.",
                                        "selectSomeItems": qtypelabelledBy
                                    }
                                    }
                                    disableSearch={qtypedisableSearch}
                                    hasSelectAll={qtypeselectall}
                                    options={this.props.getSections}
                                    value={this.props.stateData.qbquestiontypesvalue}
                                    onChange={(e) => this.props.handleMultipleSelectInputChange(e, "qbquestiontypes")}
                                    labelledBy={"Section"}
                                />

                                {/*<SelectDropDown
                                        handleChange={this.props.pselecthandleInputChange}
                                        name="section"
                                        options={this.getSections()}
                                        placeholderName={'section'}
                                        dropdownIndicator={{ DropdownIndicator }}
                                    />*/}
                            </Form.Group>
                        </Col>
                    </Row>


                    {
                        this.props.stateData.currentStep != 5 ?
                            (
                                <Row>
                                    <Col sm={12}>
                                        <p className="errorCls">Note : If dosen't select Start Date & Time, it will saved to Draft. </p>
                                    </Col>
                                    <Col sm={12}>
                                        <Button type="button"
                                            className="btn text-uppercase center-auto mt-3 btn-light-blue"
                                            onClick={(e) => { this.props.ParenthandleFormSubmit(e, "Draft"); }}> Assign & Schedule Quiz
                                        </Button>

                                    </Col>
                                    {/* <Col sm={6}>
                                    <Button type="button"
                                        className="btn btn-success text-uppercase px-lg-5 ml-1"
                                        onClick={(e) => {this.props.ParenthandleFormSubmit(e, "Assign");}}> Assign Quiz
                                    </Button>
                                </Col>*/}
                                </Row>
                            )
                            :
                            ("")
                    }

                    {
                        this.props.stateData.currentStep != 5 ?
                            (
                                <Row>
                                    <Col sm={12}>
                                        {this.props.stateData.spinnerStatus == "1" ? (<div class="spinner-border text-primary"></div>) : ("")}
                                    </Col>
                                </Row>
                            )
                            :
                            ("")
                    }

                </Modal.Body>
            </Modal>
        )
    }
}

export default QuizModal
